import { render } from "./AllertComponent.vue?vue&type=template&id=1146c606"
import script from "./AllertComponent.vue?vue&type=script&lang=js"
export * from "./AllertComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__